/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.
 */

import type { VNode } from "preact";
import { Link } from "../routing/Link.js";
import { Header } from "../ui/Header.js";
import { useTranslation } from "../context/translation.js";
import { useLocation } from "wouter-preact";

export function NotFoundScreen(): VNode {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();
  return (
    <div class="max-w-3xl space-y-6">
      <Header
        onBack={() => setLocation("/orders")}
        backLabel={t`Orders`}
        title={t`Page not found`}
        subtitle={t`This address does not match a screen in the merchant portal.`}
      />
      <div class="rounded-xl border border-gray-200 bg-white p-6 shadow-xs">
        <p class="text-sm text-gray-700">{t`Choose a safe place to continue:`}</p>
        <div class="mt-5 flex flex-wrap gap-3">
          <Link
            href="/orders"
            class="rounded-md bg-taler-brand px-4 py-2 text-sm font-semibold text-white hover:bg-blue-900"
          >
            {t`Go to orders`}
          </Link>
          <Link
            href="/setup"
            class="rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            {t`Open setup status`}
          </Link>
          <Link
            href="/tutorial"
            class="rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            {t`Open user guide`}
          </Link>
        </div>
      </div>
    </div>
  );
}
